module.exports = __webpack_public_path__ + "static/media/PianoMaster.a57e81e4.jpg";